import api from "../../../config/gatewayConfig";
import { httpClient, silentPollingConfig } from "../../httpClient";

export const apiAccountProvider = {
  modificaAccount: async (payload) => {
    return httpClient.post(api.modificaAccount, payload);
  },
  eliminaAccount: async (payload) => {
    return httpClient.post(api.eliminaAccount, payload);
  },
  getVendorProfile: async () => {
    return httpClient.post(api.getVendorProfile, {}, silentPollingConfig);
  },
};

